<script setup lang="ts">
import { computed, ref, watch } from 'vue'

import { useAuthStore } from '@/stores/auth'

defineProps<{ compact?: boolean }>()

const auth = useAuthStore()
const pictureFailed = ref(false)
watch(() => auth.identity?.picture, () => { pictureFailed.value = false })
const initial = computed(() => auth.displayName.trim().charAt(0).toUpperCase() || 'U')
</script>

<template>
  <RouterLink
    v-if="auth.isAuthenticated"
    to="/profile"
    class="account-chip"
    :class="{ 'account-chip--compact': compact }"
    :aria-label="`Open profile for ${auth.displayName}`"
  >
    <span class="account-chip__avatar">
      <img
        v-if="auth.identity?.picture && !pictureFailed"
        :src="auth.identity.picture"
        alt=""
        referrerpolicy="no-referrer"
        @error="pictureFailed = true"
      >
      <template v-else>{{ initial }}</template>
    </span>
    <span
      v-if="!compact"
      class="account-chip__name"
    >{{ auth.displayName }}</span>
  </RouterLink>
  <button
    v-else
    type="button"
    class="account-chip account-chip--guest"
    :class="{ 'account-chip--compact': compact }"
    @click="auth.openSignIn()"
  >
    Sign in
  </button>
</template>
